(() => {
  const STYLE_ID = "pi-upcart-shadow-style";
  // Main (parent) product row id prefix (before ":")
  const MAIN_ID_PREFIXES = ["48109480804577"];
  // Handling-fee product row id prefix (before ":")
  const FEE_ID_PREFIXES = ["48187424997601"];

  const css = `
    /* Hide fee item ONLY when main item is not in the products section */
    ${MAIN_ID_PREFIXES.map(
      (main) =>
        `.upcart-products-section:not(:has(.upcart-product-item[id^="${main}:"])) ${FEE_ID_PREFIXES.map((fee) => `.upcart-product-item[id^="${fee}:"]`).join(", ")}`,
    ).join(", ")} { display: none !important; }

    /* Disable interactions on fee item */
    ${FEE_ID_PREFIXES.map((p) => `.upcart-product-item[id^="${p}:"]`).join(", ")} { pointer-events: none !important; }

    /* If you ever switch from hiding the whole row to hiding parts,
       keep these scoped to the handling-fee row only. */
    ${FEE_ID_PREFIXES.map((p) => `.upcart-product-item[id^="${p}:"] .upcart-product-image-wrapper`).join(", ")} { display: none !important; }
    ${FEE_ID_PREFIXES.map((p) => `.upcart-product-item[id^="${p}:"] .styles_TrashButton__deleteButton__`).join(", ")} { display: none !important; }
    ${FEE_ID_PREFIXES.map((p) => `.upcart-product-item[id^="${p}:"] .styles_ProductRow__stepper__`).join(", ")} { display: none !important; }

    #UpcartPopup ${FEE_ID_PREFIXES.map((p) => `.upcart-product-item[id^="${p}:"] .Stack__item--fill`).join(", #UpcartPopup ")} {
      display: flex !important;
      justify-content: space-between !important;
      margin-left: 0px;
    }
      .styles_Footer__ {
        padding-block-end: 0px;
    }
  `;

  function ensureStyle(shadowRoot) {
    if (!shadowRoot || shadowRoot.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = css;
    shadowRoot.appendChild(style);
  }

  function tryInject() {
    // UpCart is an app; we don’t know the host tag name, so scan for shadow roots that contain UpCart classes.
    document.querySelectorAll("*").forEach((el) => {
      const sr = el.shadowRoot;
      if (!sr) return;
      if (sr.querySelector(".upcart-product-item") || sr.querySelector(".upcart-product-image-wrapper")) {
        ensureStyle(sr);
      }
    });
  }

  // Initial + keep-alive for dynamic renders.
  tryInject();
  const mo = new MutationObserver(() => tryInject());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

